import axios from 'axios';

const apiUrl = 'https://wvg4ohhlqj7fnaszzzcbnpxr2a0tvdvq.lambda-url.eu-west-1.on.aws/';

export const SSOauth = axios.create({
  baseURL: apiUrl,
});

export const SSOsingleUserDataRequest = axios.create({
  baseURL: `${apiUrl}get_user`,
});

export const APIindustryClientListrequest = axios.create({
  baseURL: `${apiUrl}clientsbysector2`,
});

export const APIClientListrequest = axios.create({
  baseURL: `${apiUrl}clientsbysector2/0`,
});

export const APIsummaryRequest = axios.create({
  baseURL: `${apiUrl}summary2`,
});

export const APIindustryOverviewRequest = axios.create({
  baseURL: `${apiUrl}overview2`,
});

export const APIPerformanceRequest = axios.create({
  baseURL: `${apiUrl}overview3`,
});
